/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAppRequestDeclineMutationVariables = Types.Exact<{
  appRequestId: Types.Scalars['ID']['input'];
  reason?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IAppRequestDeclineMutation = {
  __typename?: 'Mutation';
  appRequestDecline?: {
    __typename?: 'AppRequestDeclinePayload';
    errors?: Array<string> | null;
    success: boolean;
    appRequest?: { __typename?: 'AppRequest'; id: string } | null;
  } | null;
};

export const AppRequestDeclineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'appRequestDecline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appRequestId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appRequestDecline' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appRequestId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'appRequestId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'reason' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAppRequestDeclineMutation, IAppRequestDeclineMutationVariables>;
